import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { QuickAccessResultsModule } from '@shared/components/header/quick-access/components/quick-access-results.module';
import { SharedDirectivesModule } from '@shared/directives/shared-directives.module';
import { WidgetModule } from '@widgets/widgets.module';
import { QuickAccessComponent } from './quick-access/quick-access.component';

@NgModule({
  declarations: [QuickAccessComponent],
  imports: [
    CommonModule,
    WidgetModule,
    SharedDirectivesModule,
    MatTooltipModule,
    QuickAccessResultsModule,
  ],
  exports: [QuickAccessComponent, QuickAccessResultsModule],
})
export class QuickAccessModule {}
